export default [
  {
    path: '/new-releases',
    name: 'Music',
    component: () =>
      import(/* webpackChunkName: 'new-releases' */ './views/Index.vue')
  }
]
